import api from '@/libs/axiosInstance';
import { useAuth } from '@/contexts/auth-context';
import type {
  ApiResponse,
  PartnerSuccessFeeBillingQuery,
  PartnerSuccessFeeBillingSummary,
} from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export const PARTNER_SUCCESS_FEES_QUERY_KEY = ['partner-success-fees'] as const;

export type PartnerSuccessFeeQueryInput = PartnerSuccessFeeBillingQuery;

export const partnerSuccessFeesQueryKey = (brandId: string, input: PartnerSuccessFeeQueryInput) =>
  [...PARTNER_SUCCESS_FEES_QUERY_KEY, brandId, input] as const;

async function fetchPartnerSuccessFees(
  input: PartnerSuccessFeeQueryInput
): Promise<PartnerSuccessFeeBillingSummary> {
  const response = await api.get<ApiResponse<PartnerSuccessFeeBillingSummary>>(
    '/dashboard/billing/partner-success-fees',
    { params: input }
  );
  if (!response.data.success || !response.data.data) {
    throw new Error(response.data.message || 'Failed to fetch partner success fees');
  }
  return response.data.data;
}

export function usePartnerSuccessFeesQuery(input: PartnerSuccessFeeQueryInput, enabled: boolean) {
  const { user } = useAuth();
  const brandId = user?.currentBrandId ?? user?.currentBrand?.id ?? '';

  return useQuery({
    queryKey: partnerSuccessFeesQueryKey(brandId, input),
    queryFn: () => fetchPartnerSuccessFees(input),
    enabled: enabled && Boolean(brandId),
    staleTime: 60_000,
  });
}
